import { api } from "../api";

export const getAllOperadores = function (lockerId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/operadores/${lockerId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getAlloperadores " + error);
        });
};

export const getOperadorById = function (operadorId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/operadores/${operadorId}`;

    api
        .get(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. getOperadorById " + error);
        });
};

export const saveOperador = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/operadores`;

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. saveOperador " + error);
        });
};

export const deleteOperador = function (operadorId, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/operadores/${operadorId}`;

    api
        .delete(URL)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. deleteOperador " + error);
        });
};

export const updateOperador = function (operadorId, data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/operadores/${operadorId}`;

    api
        .put(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. updateOperador " + error);
        });
};
